module.exports = __webpack_public_path__ + "img/dea-formazione-ico-asl-orientamento.39a0a4ae.svg";